import $cookies from 'vue-cookies';

const aclDirective = {
    inserted:function (el,binding) {
        const hasAuth = function (need,have) {
            return have[need[0]].some((item)=> need[1].includes(item))
        }
        const haveAuths = $cookies.get('user').permission;
        if(!hasAuth(binding.value,haveAuths)){
            el.style = "display:none";
        }
    }
}

const roleDirective = {
    inserted:function (el,binding) {
        const hasAuth = function (need,have) {
            return have.includes(role)
        }
        const role = $cookies.get('role')
        if(!hasAuth(role,binding.value)){
            el.style = "display:none";
        }
    }
}

export {aclDirective,roleDirective}
